import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getBookList } from '@/views/custom-layout/api';
import draggable from 'vuedraggable';
export default {
  name: 'saas_staff_library_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: Object,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    tabListFlat: Array
  },
  components: {
    draggable: draggable
  },
  data: function data() {
    return {
      typeList: [],
      moduleList: [],
      bookList: [],
      currentBook: {}
    };
  },
  methods: {
    initProps: function initProps() {
      this.value.config.books = [];
      this.currentBook = {};
      this.bookList = [];
    },
    changeBookCategory: function changeBookCategory() {
      this.initProps();
      this.remoteBook();
    },
    changeDisplayMode: function changeDisplayMode(val) {
      this.value.config.book_category = {};
      this.initProps();
      val === '2' && this.remoteBook();
    },
    changeBookType: function changeBookType() {
      this.value.config.book_category = {};
      this.initProps();
      this.value.config.display_mode === '2' && this.remoteBook();
    },
    changeModulePlate: function changeModulePlate() {
      this.value.config.book_category = {};
      this.initProps();
    },
    deleteBook: function deleteBook(index) {
      if (typeof index === 'number') {
        this.value.config.books.splice(index, 1);
      } else {
        this.value.config.books = [];
      }
    },
    disabledBook: function disabledBook(book_id) {
      var book = this.value.config.books.find(function (i) {
        return i.book_id === book_id;
      });
      return book !== undefined;
    },
    addBook: function addBook() {
      if (!this.currentBook.book_id) {
        this.$message.error('请先选择一本书籍');
        return;
      }
      if (this.value.config.display_mode === '1' && this.value.config.books.length >= this.minLength) {
        this.$message.error("\u6309\u5206\u7C7B\u5C55\u793A\u6700\u591A\u6DFB\u52A0".concat(this.minLength, "\u672C\u4E66\u7C4D"));
        return;
      }
      this.value.config.books.push(this.currentBook);
      this.currentBook = {};
      this.$refs.form.validateField('books');
    },
    remoteBook: function remoteBook() {
      var _this = this;
      var book_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _this$value$config = this.value.config,
        book_type = _this$value$config.book_type,
        module_plate_id = _this$value$config.module_plate_id,
        _this$value$config$bo = _this$value$config.book_category,
        book_category = _this$value$config$bo === void 0 ? {} : _this$value$config$bo;
      getBookList({
        customer_id: this.info.customer_id,
        book_type: book_type,
        module_plate_id: module_plate_id,
        category_name: book_category === null || book_category === void 0 ? void 0 : book_category.category_name,
        pagesize: 20,
        page: 1,
        book_name: book_name
      }).then(function (res) {
        _this.bookList = res.data;
      });
    },
    changeType: function changeType(item) {
      this.value.config.show_type = item.id;
    }
  },
  computed: {
    minLength: function minLength() {
      return {
        1: 5,
        2: 4,
        3: 3
      }[this.value.config.show_type];
    },
    rules: function rules() {
      return {
        show_type: [{
          required: true,
          message: '请先选择一种样式',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '名称不可为空',
          trigger: 'change'
        }, {
          min: 1,
          max: 10,
          message: '字数应大于等于1个字符小于10个字符!',
          trigger: 'change'
        }],
        more_name: [{
          required: true,
          message: '更多按钮名称不可为空',
          trigger: 'change'
        }, {
          min: 1,
          max: 10,
          message: '字数应大于等于1个字符小于10个字符!',
          trigger: 'change'
        }],
        bg_color: [{
          required: true,
          message: '背景色不可为空',
          trigger: 'change'
        }],
        module_plate_id: [{
          required: true,
          message: '职工书屋模块不可为空',
          trigger: 'change'
        }],
        book_type: [{
          required: true,
          message: '选项不可为空',
          trigger: 'change'
        }],
        display_mode: [{
          required: true,
          message: '选项不可为空',
          trigger: 'change'
        }],
        book_category: [{
          required: true,
          validator: function validator(_, value, callback) {
            if (value && value.id) {
              callback();
            } else {
              callback('请选择书籍分类');
            }
          }
        }],
        books: [{
          required: true,
          type: 'array',
          min: this.minLength,
          message: "\u8BF7\u81F3\u5C11\u9009\u62E9".concat(this.minLength, "\u672C\u4E66\u7C4D"),
          trigger: 'change'
        }],
        margin_top: [{
          type: 'number',
          message: '间距必须为数字值'
        }],
        z_index: [{
          required: true,
          pattern: /^(?:[1-9]|[1-9][0-9])$/,
          message: '请输入1-99之间的整数！'
        }]
      };
    }
  },
  created: function created() {
    var _this$tabListFlat$fin,
      _this2 = this;
    var _ref = ((_this$tabListFlat$fin = this.tabListFlat.find(function (i) {
        return i.key === _this2.value.key;
      })) === null || _this$tabListFlat$fin === void 0 ? void 0 : _this$tabListFlat$fin.config_default_value) || {},
      _ref$typeList = _ref.typeList,
      typeList = _ref$typeList === void 0 ? [] : _ref$typeList;
    this.typeList = typeList;
    this.moduleList = this.customerModuleList.filter(function (i) {
      return i.module_type === 'staff_library';
    }); // 只展示职工书屋类型菜单
    this.$set(this.value, 'config', _objectSpread({
      show_type: this.value.show_type || 1,
      // 兼容新老组件 默认预置类型为图片是图
      name: '',
      more_name: '查看更多',
      bg_color: '#ffffff',
      module_plate_id: this.moduleList.length === 1 ? this.moduleList[0].id : '',
      book_type: '1',
      display_mode: '1',
      book_category: {},
      books: [],
      margin_top: 15,
      //兼容新老组件 默认预置15px
      z_index: 2
    }, this.value.config));
  }
};